import * as React from 'react';
import { toast } from 'react-toastify';
import DriverJobsSiteDeparturePlanChangesData from './DriverJobsSiteDeparturePlanChanges';
import type { PlanChanges } from './models/DriverJobInterfaces';
import { useState } from 'react';

interface DriverJobsSiteDepartureCompleteProps {
    completeJob: PlanChanges;
    isPickup: boolean;  //true if all jobs are pickups
    back(): void;
    updatePlanChangesNumber(fieldName: string, fieldValue: number): void;
    updatePlanChangesText(fieldName: string, fieldValue: string): void;
    updatePlan(planFile: File): void;
    next(): void;
}

const DriverJobsSiteDepartureCompleteData = (props: DriverJobsSiteDepartureCompleteProps) => {
    const [errors, setErrors] = useState<{ [key: string]: string }>({});

    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const back = (e: any) => {
        e.preventDefault();

        props.back();
    }

    const clearError = (errorItem: string) => {
        let errorList = errors;
        delete errorList[errorItem];

        setErrors(errorList);
    }

    const updateNumber = (fieldName: string, fieldValue: number) => {
        clearError(fieldName);
        props.updatePlanChangesNumber(fieldName, fieldValue);
    }

    const updateText = (fieldName: string, fieldValue: string) => {
        clearError(fieldName);
        props.updatePlanChangesText(fieldName, fieldValue);
    }

    const updatePlan = (planFile: File) => {
        clearError("plan");
        props.updatePlan(planFile);
    }

    const validate = () => {
        let jobItems = props.completeJob;
        let errorList: any = {};
        let formIsValid = true;

        var planChanges = jobItems.planChanges * 1;
        if (planChanges < 0) {
            formIsValid = false;
            errorList["planChanges"] = "Plan Changes is required";
        } else if (planChanges === 1) {
            if (jobItems.plan.size === 0) {
                formIsValid = false;
                errorList["plan"] = "You must upload a photo of the plan changes";
            }
            if (!jobItems.planComments) {
                formIsValid = false;
                errorList["planComments"] = "Plan Comments are required";
            }
        }

        setErrors(errorList);
        return formIsValid;
    }

    const next = (e: any) => {
        e.preventDefault();
        if (validate()) {
            props.next();
        } else {
            toast.error("Please check validation errors before going Next!");
        }
    }

    let planChangesQuestions = <DriverJobsSiteDeparturePlanChangesData planChanges={props.completeJob} isPickup={props.isPickup} errors={errors} updateNumber={updateNumber} updateText={updateText} updatePlan={updatePlan} />

    return (
        <div>
            <div className="mobileFont marginTop10 marginBottom10">
                <div className="makeitflexspacebetween marginBottom10">
                    <h2 className="mobile-margin">Job Complete</h2>
                    <i className="mobile-icon-grey fas fa-arrow-alt-circle-left mobileMenuSize" onClick={(e) => back(e)}></i>
                </div>
                {planChangesQuestions}
                <div className="defaultbutton__container--right marginTop10">
                    <i className="mobile-icon-green fas fa-arrow-alt-circle-right mobileMenuSize" onClick={(e) => next(e)}></i>
                </div>
            </div>
        </div>
    );
}

export default DriverJobsSiteDepartureCompleteData;